export default __webpack_public_path__ + "assets/alex.6f94f52d.png";